import { Chip, MoreButton } from '@design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

const links = [
  {
    label: translations.COMMON.EDIT,
    value: 'edit',
  },
  {
    label: translations.COMMON.DELETE,
    value: 'delete',
  },
];

export type ObserverProps = {
  name: string;
  email: string;
  index: number;
  color?: string;
  signing?: boolean;
  actionsEnabled?: boolean;
  handleDeleteObserver: (index: any) => void;
  handleEditObserver: (index: any) => void;
};

export const Observer: React.FC<ObserverProps> = ({
  name,
  email,
  index,
  signing = false,
  actionsEnabled = true,
  handleDeleteObserver,
  handleEditObserver,
}) => {
  const { t } = useTranslation();
  const onClick = (value, index) => {
    if (value === 'delete' && handleDeleteObserver) handleDeleteObserver(index);
    if (value === 'edit' && handleEditObserver) handleEditObserver(index);
  };

  return (
    <div>
      {!signing && (
        <div className="mb-4 flex text-left text-paragraph font-bold text-gray-500">
          <span className="relative top-2 ">
            {t(translations.COMMON.OBSERVER)}
          </span>
          {actionsEnabled ? (
            <MoreButton
              className="relative top-2 ml-auto"
              items={links as any}
              onClick={(value) => onClick(value, index)}
            />
          ) : null}
        </div>
      )}
      <div className="flex flex-col">
        <div className="mb-2 inline-flex w-full flex-row">
          <p className="font-semi-bold">{name}</p>
          {signing && actionsEnabled && (
            <MoreButton
              className="relative top-2 ml-auto"
              items={links as any}
              onClick={(value) => onClick(value, index)}
            />
          )}
        </div>
        <p>
          {t(translations.COMMON.EMAIL)}:{' '}
          <span className=" font-bold">{email}</span>
        </p>
      </div>
    </div>
  );
};
